import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/layout/NavBar";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/layout/Footer";
import { AuthProvider } from "./context/AuthContext";
import Intro from "./pages/Intro";
import Home from "./pages/Home";
import Nominations from "./pages/Nominations";
import Vote from "./pages/Vote";
import ArtistProfile from "./pages/ArtistProfile";
import About from "./pages/About";
import Press from "./pages/Press";
import PressArticle from "./pages/PressArticle";
import PressKit from "./pages/PressKit";
import Trophees from "./pages/Trophees";
import Partenaires from "./pages/Partenaires";
import Bibliotheque from "./pages/Bibliotheque";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Ceremonie from "./pages/Ceremonie";
import Archives from "./pages/Archives";
import NotFound from "./pages/NotFound";
import MentionsLegales from "./pages/MentionsLegales";
import Jury from "./pages/Jury";
import Spectacles from "./pages/Spectacles";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isIntro = location.pathname === "/";

  return (
    <>
      <ScrollToTop />
      {!isAdmin && !isIntro && <NavBar />}
      <main>
        <Routes>
          <Route path="/" element={<Intro />} />
          <Route path="/home" element={<Home />} />
          <Route path="/nominations" element={<Nominations />} />
          <Route path="/voter" element={<Vote />} />
          <Route path="/artiste/:slug" element={<ArtistProfile />} />
          <Route path="/manifeste" element={<About />} />
          <Route path="/presse" element={<Press />} />
          <Route path="/presse/kit" element={<PressKit />} />
          <Route path="/presse/:id" element={<PressArticle />} />
          <Route path="/trophees" element={<Trophees />} />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/bibliotheque" element={<Bibliotheque />} />
          <Route path="/jury" element={<Jury />} />
          <Route path="/spectacles" element={<Spectacles />} />
          <Route path="/ceremonie" element={<Ceremonie />} />
          <Route path="/archives" element={<Archives />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && !isIntro && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
